<div class="practice-header" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <div class="breadcrumb-container">
      <qai-breadcrumb-list [items]="getBreadcrumbItems()"></qai-breadcrumb-list>
    </div>

    <span class="practice-heading">{{ heading }} {{ 'reportingV2.PERSONALIZED_PRACTICE_LABEL' | transloco }}</span>

    <div class="team-selector-container">
      <qai-field [label]="'reportingV2.TEAMS' | transloco">
        <qai-multiselect
          #multiselect
          [options]="searchOptions"
          [placeholder]="'reportingV2.SEARCH_TEAMS' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [startIcon]="'search'"
          (valueChange)="onTeamChange($event)"
          [value]="selectedTeams"
          [allOptionMode]="allTeams"
          [persistSearch]="true"
        >
        </qai-multiselect>
      </qai-field>
    </div>
  </qai-inner-wrap>
</div>
